// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: '69b772ab-46ad-4b84-bc35-b3b611ee4ead',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'd1452867-f505-4d0a-91a0-6eef0fc98e5d',
      type: 'Container',
      name: 'lightContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '69b772ab-46ad-4b84-bc35-b3b611ee4ead'
    },
    {
      id: '9bb10bad-9170-415e-bd7f-99edabb34fbd',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Start_Light',
      parent: 'd1452867-f505-4d0a-91a0-6eef0fc98e5d'
    },
    {
      id: '4360cce6-665b-419a-ab06-d6345712fa6e',
      type: 'Sprite',
      name: 'redLight',
      className: '',
      x: -96,
      y: 18,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Start_Light_Red',
      parent: 'd1452867-f505-4d0a-91a0-6eef0fc98e5d'
    },
    {
      id: '10f7758b-5377-4a19-9319-c6dafa2f2f85',
      type: 'Sprite',
      name: 'yellowLight',
      className: '',
      x: 0,
      y: 18,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Start_Light_Yellow',
      parent: 'd1452867-f505-4d0a-91a0-6eef0fc98e5d'
    },
    {
      id: '938991e6-8449-4dbf-b7a9-eca53cbc03eb',
      type: 'Sprite',
      name: 'greenLight',
      className: '',
      x: 96,
      y: 18,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Start_Light_Green',
      parent: 'd1452867-f505-4d0a-91a0-6eef0fc98e5d'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: '90fb1a61-592d-4bba-b0ff-d4c5e2c63375',
      name: 'CountdownAnimation',
      playingSpeed: 1,
      totalDuration: 2350,
      blocks: [
        {
          id: 'bade9e0c-305d-40c7-9236-e9700cbdb3a6',
          type: 'Setter',
          name: 'rootSetter',
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'root',
          disabled: false
        },
        {
          id: 'd55ce59b-c554-4a31-bec2-c689f5fe93bc',
          type: 'Tween',
          name: 'rootScaleTween',
          duration: 400,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'BackOut',
          disabled: false
        },
        {
          id: 'd76f50ca-0f34-4537-88a4-23b916df0bdd',
          type: 'Tween',
          name: 'New_tween_1',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 551,
          sourceName: 'lightContainer',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'b912319f-2829-42d9-a281-c6cd72518e50',
          type: 'Tween',
          name: 'light',
          duration: 100,
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 699,
          sourceName: 'redLight',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '7034bff6-8a62-4b96-9a8f-315939aa0769',
          type: 'Tween',
          name: 'New_tween_1_copy',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 801,
          sourceName: 'lightContainer',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'd1aa4c69-4b66-439d-8d77-30ad458959d7',
          type: 'Tween',
          name: 'New_tween_1_copy_1',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 1051,
          sourceName: 'lightContainer',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '43849e4e-7c67-4983-b01c-7b2d1a73557c',
          type: 'Tween',
          name: 'light_copy',
          duration: 100,
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 1201,
          sourceName: 'redLight',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'd87e536f-c262-4ec2-b975-dd64d1defa15',
          type: 'Tween',
          name: 'light_copy_1',
          duration: 100,
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 1201,
          sourceName: 'yellowLight',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'e7638afe-27b9-4edd-a10c-9d360f77b31f',
          type: 'Tween',
          name: 'New_tween_1_copy_copy',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1301,
          sourceName: 'lightContainer',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '97aa0651-b0fc-4950-b600-ca3ce2cd9159',
          type: 'Tween',
          name: 'New_tween_1_copy_1_copy',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 1551,
          sourceName: 'lightContainer',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '64e2f01b-c697-4836-a821-a84a0b82274f',
          type: 'Tween',
          name: 'light_copy_copy',
          duration: 100,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 1701,
          sourceName: 'yellowLight',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '66c3a305-c7b7-4308-a9a8-46b0d1e91ccd',
          type: 'Tween',
          name: 'light_copy_1_copy',
          duration: 100,
          track: 4,
          target: {
            alpha: 1
          },
          startAt: 1701,
          sourceName: 'greenLight',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '59ce42b5-4453-4e28-87c9-86c86f9f3d85',
          type: 'Tween',
          name: 'New_tween_1_copy_copy_copy',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1801,
          sourceName: 'lightContainer',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'f419f3f5-29b7-4b8d-9003-1fca636b681e',
          type: 'Tween',
          name: 'shine_copy_2',
          duration: 300,
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 2049,
          sourceName: 'lightContainer',
          easing: 'CubicInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class RaceEventStartLightsLayout {
  static raw = raw;
  root!: Container;
  lightContainer!: Container;
  redLight!: Sprite;
  yellowLight!: Sprite;
  greenLight!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class CountdownAnimation {
  Layout: {
    root: object;
    lightContainer: object;
    redLight: object;
    yellowLight: object;
    greenLight: object;
  };

  BlockTypeByName: {
    rootSetter: object;
    rootScaleTween: object;
    New_tween_1: object;
    light: object;
    New_tween_1_copy: object;
    New_tween_1_copy_1: object;
    light_copy: object;
    light_copy_1: object;
    New_tween_1_copy_copy: object;
    New_tween_1_copy_1_copy: object;
    light_copy_copy: object;
    light_copy_1_copy: object;
    New_tween_1_copy_copy_copy: object;
    shine_copy_2: object;
  };

  flowData = raw.animations[0];
}
